// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2LmMF","range":"MonthRangeSwitch_range__-i6Uq","disabled":"MonthRangeSwitch_disabled__2hZqs"};